module.exports = __webpack_public_path__ + "static/img/H41.f24d98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/q_and_a/H41.png
// module id = +owB
// module chunks = 0